module.exports = __webpack_public_path__ + "img/cvs-submitted.a0ff89c1.svg";